import { Middleware } from '@nuxt/types'

interface ModalComponentsState {
  component: unknown
}

// Close the current modal (if available) on navigation.
const closeModals: Middleware = ({ store }) => {
  const modalComponents = store.state.modalComponents as ModalComponentsState
  if (modalComponents.component) {
    store.dispatch('modal/close')
  }
}

export default closeModals
